// extracted by mini-css-extract-plugin
export default {"body":"style_body__7OV53","input":"style_input__FI24L","timer":"style_timer__DhEcU","error":"style_error__Qdj4R"};